export default __webpack_public_path__ + "static/media/H_Harpa.fa7c5345.svg";